// https://stackoverflow.com/a/48521127/4204919
import { PIXI } from '@colonist/pixi';
export class RoundedBgView extends PIXI.Graphics {
    isSameBg(texture) {
        return texture == this.texture;
    }
    constructor(w, h, container, texture, radius = 5){
        super();
        this.texture = texture;
        this.radius = radius;
        const matrix = new PIXI.Matrix();
        matrix.scale(w / texture.width, h / texture.height);
        this.beginTextureFill({
            texture: texture,
            color: 0xffffff,
            alpha: 1,
            matrix: matrix
        });
        this.drawRoundedRect(0, 0, w, h, this.radius);
        this.endFill();
        container.addChildAt(this, 0);
    }
}
